import { render, staticRenderFns } from "./switch.vue?vue&type=template&id=d05e83fc&"
import script from "./switch.vue?vue&type=script&lang=js&"
export * from "./switch.vue?vue&type=script&lang=js&"
import style0 from "./switch.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/franciscoriquelme/Documents/Elipse.ia/Proyectos/elipse-citas/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d05e83fc')) {
      api.createRecord('d05e83fc', component.options)
    } else {
      api.reload('d05e83fc', component.options)
    }
    module.hot.accept("./switch.vue?vue&type=template&id=d05e83fc&", function () {
      api.rerender('d05e83fc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/vue/components/reportes/llamada_seguimiento/switch.vue"
export default component.exports